var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLockIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 8.37762V7.37762C6 4.06391 8.68629 1.37762 12 1.37762C15.3137 1.37762 18 4.06391 18 7.37762V8.37762H20C20.5523 8.37762 21 8.82534 21 9.37762V21.3776C21 21.9299 20.5523 22.3776 20 22.3776H4C3.44772 22.3776 3 21.9299 3 21.3776V9.37762C3 8.82534 3.44772 8.37762 4 8.37762H6ZM19 10.3776H5V20.3776H19V10.3776ZM11 16.11C10.4022 15.7642 10 15.1179 10 14.3776C10 13.273 10.8954 12.3776 12 12.3776C13.1046 12.3776 14 13.273 14 14.3776C14 15.1179 13.5978 15.7642 13 16.11V18.3776H11V16.11ZM8 8.37762H16V7.37762C16 5.16848 14.2091 3.37762 12 3.37762C9.79086 3.37762 8 5.16848 8 7.37762V8.37762Z",
    fill: "#1A1645"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/lock-icon.80785acadbf824561f6ef4960bfc594b.svg";
export { ForwardRef as ReactComponent };